function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2EB57E",
  d: "M29.652 13.773V15c0 8.318-6.604 15-14.826 15C6.604 30 0 23.318 0 15S6.604 0 14.826 0c2.022 0 4.178.41 6.065 1.364.674.272.944 1.09.674 1.772-.27.682-1.078.955-1.752.682-1.617-.682-3.235-1.09-4.987-1.09-6.739 0-12.13 5.454-12.13 12.272 0 6.818 5.391 12.273 12.13 12.273 6.74 0 12.13-5.455 12.13-12.273v-1.227c0-.818.54-1.364 1.348-1.364.809 0 1.348.546 1.348 1.364zm.944-12c-.54-.546-1.348-.546-1.887 0L14.826 15.818l-3.1-3.136c-.539-.546-1.348-.546-1.887 0-.539.545-.539 1.363 0 1.909l4.044 4.09c.27.274.674.41.943.41.27 0 .674-.136.944-.41l14.826-15c.539-.545.539-1.363 0-1.908z"
});

var SvgSuccessIcon = function SvgSuccessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success-icon.c3a4ba7e.svg";
export { ForwardRef as ReactComponent };